import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

interface InformesBackButtonProps {
  to: string;
  label?: string;
  useBrowserBack?: boolean;
}

const InformesBackButton: React.FC<InformesBackButtonProps> = ({
  to,
  label = 'Volver',
  useBrowserBack = false
}) => {
  const navigate = useNavigate();
  const handleBack = () => {
    if (useBrowserBack && window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(to);
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<ArrowBackIcon />}
      onClick={handleBack}
      sx={{
        borderRadius: 2,
        px: 2,
        py: 1,
        textTransform: 'none',
        fontWeight: 500,
      }}
    >
      {label}
    </Button>
  );
};

export default InformesBackButton;
